module.exports = {"110114001":"城北街道","110114002":"南口地区","110114003":"马池口地区","110114004":"沙河地区","110114005":"城南街道","110114007":"东小口地区","110114008":"天通苑北街道","110114009":"天通苑南街道","110114010":"霍营街道","110114011":"回龙观街道","110114012":"龙泽园街道","110114013":"史各庄街道","110114104":"阳坊镇","110114110":"小汤山镇","110114111":"南邵镇","110114112":"崔村镇","110114113":"百善镇","110114115":"北七家镇","110114116":"兴寿镇","110114118":"流村镇","110114119":"十三陵镇","110114120":"延寿镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/110114.json
// module id = 117
// module chunks = 0